import useGetWidth from './useGetWidth';

//* Must be equal to $breakpoint-width-mobile in scss/mixins/mixins.scss
const breakpoints = {
  mobile: 1024,
  tablet: 1366,
};

const useResponsive = () => {
  const width = useGetWidth();

  const isMobile = width <= breakpoints.mobile;
  const isTablet = width > breakpoints.mobile && width <= breakpoints.tablet;
  const isDesktop = width > breakpoints.tablet;

  return {
    isMobile,
    isDesktop,
    isTablet,
    width,
  };
};

export default useResponsive;
